module.exports = __webpack_public_path__ + "static/media/effect-06.21c34f96.gif";